import React from 'react';
import { PasswordExpired } from 'src/js/pages/login/passwordExpired';

export const PasswordExpiredTest: React.FunctionComponent = () => (
  <div className="test-zone">
    <PasswordExpired session={{gid:500, passwordExp: true, username: 'mike'}} />
  </div>
);
